const notificationBar = document.getElementById('barra-de-notificacion');
if (notificationBar) {
  const getShowNotification = sessionStorage.getItem('show-notificacion');
  
  const closeBtn = document.querySelector('.barra-de-notificacion__close');
  closeBtn.addEventListener('click', function () {
    sessionStorage.setItem('show-notificacion', false);
    notificationBar.classList.add('d-none');
  })

  if (getShowNotification === null) {
    notificationBar.classList.remove('d-none');
  }
}